<section class="userDropdown__user">
  <div class="userDropdown__user-row">
    @if (users[userId]?.avatarPublicUrl) {
      <img
        ppImage
        class="userDropdown__avatar"
        [src]="users[userId].avatarPublicUrl"
        />
    }

    @if (!users[userId]?.avatarPublicUrl) {
      <img
        class="userDropdown__avatar"
        [src]="EIconPath.PLACEHOLDER_USER"
        />
    }

    <p class="userDropdown__user-name">
      {{ users[userId].userName }}
    </p>
  </div>

  @if (!disabled) {
    <button
      class="userDropdown__remove-text"
      (click)="removeAssignee(); $event.stopPropagation()"
      >
      {{ message }}
    </button>
  }
</section>
